import DownIcon from '@assets/svg/table-down.svg';
import UpIcon from '@assets/svg/table-up.svg';

import { ColumnContainer, ColumnName, Direction } from './ColumnTitle.styles';

interface IColumnTitle extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  direction?: 'up' | 'down';
  onClick?: () => void;
}

export const ColumnTitle = ({ label, direction, ...rest }: IColumnTitle) => {
  return (
    <ColumnContainer {...rest}>
      <ColumnName>{label}</ColumnName>
      {!!direction && (
        <Direction>
          <img src={direction === 'up' ? UpIcon : DownIcon} alt="direction" />
        </Direction>
      )}
    </ColumnContainer>
  );
};
